import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType, } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { switchMap, map, catchError, EMPTY } from 'rxjs';
import { LeadService } from 'src/app/services/lead.service';
import { CheckMobileCodeRequestAction, CheckMobileCodeResponseAction, SendMobileCodeRequestAction, SendMobileCodeResponseAction } from './actions';

@Injectable()
export class NmjMobileVerificationEffects {
  constructor(private store: Store<any>,
    private actions$: Actions,
    private service: LeadService) {
  }

  checkMobileCode$ = createEffect(() => this.actions$.pipe(
    ofType(CheckMobileCodeRequestAction),
    switchMap((action: any) => this.service.checkMobileCode(action.data).pipe(
      map((data: any) => {
        this.service.showOk(data.message);
        return CheckMobileCodeResponseAction({ data: data.data });
      }),
      catchError(err => {
        return EMPTY;
      })
    )),
  ));

  sendMobileCode$ = createEffect(() => this.actions$.pipe(
    ofType(SendMobileCodeRequestAction),
    switchMap((action: any) => this.service.sendMobileCode(action.data).pipe(
      map((data: any) => {
        this.service.showOk(data.data.message);
        return SendMobileCodeResponseAction({ data: data.data });
      }),
      catchError(err => {
        return EMPTY;
      })
    )),
  ));

}
